<template>
  <v-container fluid>
    <v-row v-if="myob">
      <v-col>
        <myob-review :myob="myob"></myob-review>
      </v-col>
    </v-row>

    <app-title>Commissions Details</app-title>
    <v-row>
      <v-col>
        <v-card>
          <commission-detail
            detail-type="payment"
            :selected="selected"
            @paymentsSuppressed="suppressed"
            @editSelected="editSelected"
          ></commission-detail>
          <ag-grid-vue
            style="width: 100%; height: 500px;"
            class="ag-theme-balham"
            :columnDefs="headers"
            :rowData="details"
            :gridOptions="gridOptions"
            @filter-changed="updateCell"
            :defaultColDef="defaultColDef"
            rowSelection="multiple"
            @selection-changed="onSelectionChanged"
            :pinnedTopRowData="pinnedTopRowData"
            rowMultiSelectWithClick
            enableCellTextSelection
            @rowClicked="onRowSelected"
          ></ag-grid-vue>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox
          label="ShowClawbacks"
          v-model="showClawbacks"
          value="false"
        ></v-checkbox>
        <manage-clawbacks
          v-if="showClawbacks"
          ref="clawbacks"
          @clawbacksApplied="loadData"
        ></manage-clawbacks>
      </v-col>
    </v-row>
    <manual-adjustment ref="manual" @refresh="refresh"></manual-adjustment>
  </v-container>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { mapActions, mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import commissionDetail from "@/components/commissions/commissionDetail";
import myobReview from "@/components/review/MyobReview";
import ManageClawbacks from "@/components/commissions/ManageClawbacks.vue";
import CustomPinnedRowRenderer from "@/components/commissions/customPinnedRowRender.js";
import ManualAdjustment from "@/components/commissions/ManualAdjustment";

export default {
  name: "CommissionsReview",
  components: {
    "commission-detail": commissionDetail,
    AgGridVue,
    myobReview,
    ManageClawbacks,
    ManualAdjustment
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {
        headerName: "Dealer",
        field: "dealerId",
        width: 150,
        pinnedRowCellRenderer: "customPinnedRowRenderer",
        pinnedRowCellRendererParams: { style: { color: "blue" } }
      },
      {
        headerName: "Director",
        field: "directorName",
        width: 90,
        pinnedRowCellRenderer: "customPinnedRowRenderer",
        pinnedRowCellRendererParams: { style: { "font-style": "italic" } }
      },
      {
        headerName: "Customer Number",
        field: "custNo",
        width: 120
      },
      {
        headerName: "Comment",
        field: "comment",
        width: 90
      },
      {
        headerName: "CSN",
        field: "csn",
        width: 110
      },
      {
        headerName: "Summary Level",
        field: "summaryLevel",
        width: 110
      },
      {
        headerName: "Amount",
        field: "amount",
        width: 110
      },
      {
        headerName: "Order Tyoe",
        field: "orderType",
        width: 110
      }
    ];
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true
    };
    this.getRowStyle = params => {
      if (params.node.rowPinned) {
        return { "font-weight": "bold" };
      }
    };
    this.frameworkComponents = {
      customPinnedRowRenderer: CustomPinnedRowRenderer
    };
  },
  mounted() {},
  data() {
    return {
      showClawbacks: false,
      gridOptions: {},
      myob: {},
      defaultColDef: { resizeable: true, sortable: true },
      search: "",
      payments: [],
      details: [],
      loading: true,
      expanded: [],
      pinnedTopRowData: null,
      selected: [],
      headers: [
        {
          headerName: "Dealer ID",
          field: "dealerId",
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          sortable: true
        },
        {
          headerName: "Director",
          field: "directorName",
          filter: "agTextColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          sortable: true
        },
        {
          headerName: "Customer Number",
          field: "custNo",
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          sortable: true
        },
        {
          headerName: "Comment",
          field: "comment",
          filter: "agTextColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          sortable: true,
          cellRenderer: function(val) {
            return val.value == "ADSL" ? "Internet" : val.value;
          }
        },
        {
          headerName: "CSN",
          field: "csn",
          filter: "agTextColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          sortable: true
        },
        {
          headerName: "Summary Level",
          field: "summaryLevel",
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          sortable: true
        },
        {
          headerName: "Amount",
          field: "amount",
          filter: "agNumberColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          sortable: true,
          valueFormatter: this.currencyFormatter
        },
        {
          headerName: "Order Type",
          field: "orderType",
          filter: "agTextColumnFilter",
          filterParams: { applyButton: true, resetButton: true },
          sortable: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters("commissions", ["run"])
  },
  methods: {
    ...mapActions("commissions", [
      "ListInitialSummary",
      "ListInitialDetails",
      "ListRoyaltyDetails",
      "CommissionsRequest"
    ]),
    onRowSelected(val) {
      let vm = this;
      let manual = vm.$refs["manual"];
      manual.editedItem = val.data;
    },
    editSelected() {
      let vm = this;
      let manual = vm.$refs["manual"];
      manual.dialog = true;
    },
    refresh(val) {
      this.gridOptions.api.setRowData(this.gridOptions.rowData);
      this.selected = [];
    },
    async loadData(selection) {
      let vm = this;
      if (selection.runId) {
        let initials = vm.ListInitialSummary(selection).then(data => {
          if (data.myob && data.myob.missingSuppliers.length > 0)
            vm.myob = data.myob;
        });
        // let clawbacks = vm.$refs.clawbacks.collectClawBacks();
        Promise.all([initials])
          .then(data => {
            vm.payments = data.summary.summary;
            // vm.myob = data.myob;
            vm.loading = false;
          })
          .catch(err => {
            if(err.response != undefined)
              this.myob = err.response.data.myob;
          });

        if (selection.runId)
          vm.ListInitialDetails(selection)
            .then(data => {
              vm.details = data;
              vm.pinnedTopRowData = this.createData(1, vm.details, "Top");
              vm.gridOptions.api.sizeColumnsToFit();
            })
            .catch(() => {});
      }
    },
    updateCell() {
      this.$nextTick().then(() => {
        let filtered = this.gridOptions.api
          .getModel()
          .rootNode.childrenAfterFilter.map(x => x.data);
        this.pinnedTopRowData = this.createData(1, filtered, "Top");
      });
    },
    createData(count, collection) {
      var result = [];
      for (var i = 0; i < count; i++) {
        result.push({
          dealerId: "",
          directorName: "",
          custNo: "",
          comment: "",
          csn: "",
          summaryLevel: "",
          // amount: this.gridOptions.api.getModel().rootNode.childrenAfterFilter,
          amount: collection.map(x => x.amount).reduce((a, b) => a + b, 0),
          orderType: ""
        });
      }
      return result;
    },
    suppressed() {
      this.details = this.details.filter(x => !this.selected.includes(x));
      this.gridOptions.api.deselectAll();
    },
    detail(dealerID) {
      let vm = this;
      const result = vm.details.filter(x => x.dealerId == dealerID);
      return result;
    },
    ApproveToPay(run) {
      run.approvedToPay = true;
      run.amount = !run.amount ? 0 : run.amount
      let query = {
        message: `Approved Commission run ${run.runId}`,
        url: `Commissions/ApproveRunToPay/`,
        method: "post",
        body: run
      };
      this.CommissionsRequest(query)
        .then(() => {
          this.$emit("saved");
        })
        .catch(() => {});
    },
    onSelectionChanged() {
      this.selected = this.gridOptions.api.getSelectedRows();
    }
  }
};
</script>

<style scoped></style>
